<div nz-row class="login-box" nzType="flex" nzJustify="center">
  <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
    <h1 class="text">{{ "app.signup.title" | translate }}</h1>
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTpluserName">
          <nz-input-group [nzPrefix]="unamePrefix">
            <input
              type="text"
              nz-input
              formControlName="userName"
              [placeholder]="'app.label.user.name' | translate"
              [nzSize]="'large'"
              autocomplete="off"
            />
          </nz-input-group>
          <ng-template #errorTpluserName let-control>
            <ng-container *ngIf="control.hasError('required')">
              {{ 'sez.validation.required' | translate }}
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')">
              Please enter lower case character and no numerics allowed
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              {{ 'sez.validation.maxlength' | translate }}
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              {{ 'sez.validation.minlength' | translate }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control
          [nzErrorTip]="'app.signup.firstname.required' | translate"
        >
          <nz-input-group [nzPrefix]="fnamePrefix">
            <input
              type="text"
              nz-input
              formControlName="firstName"
              [placeholder]="'app.label.first-name' | translate"
              [nzSize]="'large'"
              autocomplete="off"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control
          [nzErrorTip]="'app.signup.lastname.required' | translate"
        >
          <nz-input-group [nzPrefix]="lnamePrefix">
            <input
              type="text"
              nz-input
              formControlName="lastName"
              [placeholder]="'app.label.last-name' | translate"
              [nzSize]="'large'"
              autocomplete="off"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTplEmail">
          <nz-input-group [nzPrefix]="emailPrefix">
            <input
              type="text"
              nz-input
              formControlName="email"
              [placeholder]="'app.label.email' | translate"
              [nzSize]="'large'"
              autocomplete="off"
            />
          </nz-input-group>
          <ng-template #errorTplEmail let-control>
            <ng-container *ngIf="control.hasError('required')">
              {{ "app.signup.email.required" | translate }}
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')">
              {{ "app.signup.email.validation" | translate }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTplPassword">
          <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="passwordsuffix">
            <input
              [nzSize]="'large'"
              [type]="passwordVisible ? 'text' : 'password'"
              nz-input
              [placeholder]="'app.label.password' | translate"
              formControlName="password"
              autocomplete="off"
            />
          </nz-input-group>
          <ng-template #errorTplPassword let-control>
            <ng-container *ngIf="control.hasError('required')">
              {{ "app.signup.password.required" | translate }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTplCPassword">
          <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="passwordsuffix">
            <input
              [nzSize]="'large'"
              [type]="passwordVisible ? 'text' : 'password'"
              nz-input
              [placeholder]="'app.label.cpassword' | translate"
              formControlName="cpassword"
              autocomplete="off"
            />
          </nz-input-group>
          <ng-template #errorTplCPassword let-control>
            <ng-container *ngIf="control.hasError('required')">
              {{ "app.signup.password.required" | translate }}
            </ng-container>
            <ng-container *ngIf="control.hasError('NoPassswordMatch')">
              {{ "app.signup.password.validation.mismatch" | translate }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'app.signup.aoi.required' | translate">
          <nz-input-group [nzPrefix]="aoiPrefix">
            <nz-select
              [nzSize]="'default'"
              nzMode="multiple"
              [nzPlaceHolder]="'app.signup.aoi.required' | translate"
              nzShowSearch
              formControlName="areaofinterest"
              nzAllowClear
            >
              <nz-option
                *ngFor="let option of listAreaofInterest"
                [nzLabel]="option.label"
                [nzValue]="option.value"
              >
              </nz-option>
            </nz-select>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="recaptchaEnable">
        <re-captcha formControlName="recaptchaReactive"></re-captcha>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button
            nz-button
            [nzSize]="'large'"
            [nzType]="'primary'"
            [nzBlock]="true"
            [nzLoading]="loading"
            (click)="signup()"
          >
            {{ "app.label.signup" | translate }}
          </button>
          <div class="float-left">
            {{ "app.signup.alreadyaccount" | translate }}
          </div>
          <a class="float-right" (click)="signin()">
            {{ "app.label.signin" | translate }}</a
          >
        </nz-form-control>
      </nz-form-item>
    </form>
    <ng-template #prefixLock>
      <span
        nz-tooltip
        nzTooltipTitle="{{ 'app.signup.password.required' | translate }}"
      >
        <i nz-icon nzType="lock"></i>
      </span>
    </ng-template>
    <ng-template #unamePrefix>
      <span
        nz-tooltip
        nzTooltipTitle="{{ 'app.signup.username.required' | translate }}"
      >
        <i nz-icon nzType="user"></i>
      </span>
    </ng-template>
    <ng-template #fnamePrefix>
      <span
        nz-tooltip
        nzTooltipTitle="{{ 'app.signup.firstname.required' | translate }}"
      >
        <i nz-icon nzType="contacts"></i>
      </span>
    </ng-template>
    <ng-template #lnamePrefix>
      <span
        nz-tooltip
        nzTooltipTitle="{{ 'app.signup.lastname.required' | translate }}"
      >
        <i nz-icon nzType="solution"></i>
      </span>
    </ng-template>
    <ng-template #emailPrefix>
      <span
        nz-tooltip
        nzTooltipTitle="{{ 'app.signup.email.required' | translate }}"
      >
        <i nz-icon nzType="mail"></i>
      </span>
    </ng-template>
    <ng-template #passwordsuffix>
      <i
        nz-icon
        [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
        (click)="passwordVisible = !passwordVisible"
      ></i>
    </ng-template>
    <ng-template #aoiPrefix>
      <span
        nz-tooltip
        nzTooltipTitle="{{ 'app.signup.aoi.required' | translate }}"
      >
        <i nz-icon nzType="question-circle"></i>
      </span>
    </ng-template>
  </nz-card>
</div>
